// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"5b5f864b","977":"55c9b588"}[chunkId] + ".chunk.js";
};